import styled from 'styled-components';
import { breakpoints } from 'src/styles/theme';
import { StepNavigationStyled } from '@components/v2/StepNavigation/StepNavigationStyled';

export const StepNavigationStyledOVGB = styled(StepNavigationStyled)`
    .opened,
    .closed {
        background: ${({ theme }) => theme.colors.grey6};

        .contactUsContainer {
            font-weight: bold;
            color: ${({ theme }) => theme.colors.black};

            .contactUsActionButton {
                font-weight: bold;
            }

            .contactUsTitle svg path {
                fill: ${({ theme }) => theme.colors.black};
            }
        }

        .wrapper {
            .blurryHolder {
                @media (min-width: ${breakpoints.lg}px) {
                    .icon-wrapper {
                        &:after {
                            width: 19px;
                            height: 19px;
                            display: flex;
                            content: ${({ theme }) => `url('data:image/svg+xml;utf8,
                                <svg aria-hidden="true" width="19px" height="19px" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M1.15203 18.3188L1.72319 18.8789L10.5765 9.85176L1.48033 0.914551L0.919647 1.4852L9.44565 9.86224L1.15203 18.3188Z" fill="${encodeURIComponent(
                                      theme.colors.black
                                  )}" stroke="${encodeURIComponent(theme.colors.black)}" stroke-width="1.2"></path>
                                </svg>')`};
                        }

                        svg {
                            display: none;
                        }
                    }
                }
            }
            .container {
                .nav-item {
                    &:hover,
                    &:focus-visible {
                        color: inherit;
                    }

                    .icon {
                        background: ${({ theme }) => theme.colors.grey17};
                        border-color: ${({ theme }) => theme.colors.grey17};
                        svg {
                            g {
                                fill: ${({ theme }) => theme.colors.white};
                            }
                        }
                    }
                    .withIcon {
                        background: ${({ theme }) => theme.colors.primary};
                        border-color: ${({ theme }) => theme.colors.primary};
                    }
                }
            }
        }
    }
`;
